import React from 'react';
import { useSettings } from '@/hooks/useSettings';
import { useOfferStats } from '@/hooks/useOfferStats';

export function TestPage() {
  const { generalSettings, securitySettings } = useSettings();
  const { stats } = useOfferStats();

  return (
    <div className="p-8 bg-zinc-900 min-h-screen text-white">
      <h1 className="text-3xl font-bold mb-8">Test Page - Sprawdzenie nowych funkcji</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Test useSettings */}
        <div className="bg-zinc-800 p-6 rounded-lg border border-zinc-700">
          <h2 className="text-xl font-semibold mb-4 text-orange-400">useSettings Hook</h2>
          <div className="space-y-2 text-sm">
            <p>Theme: <span className="text-green-400">{generalSettings.theme}</span></p>
            <p>Language: <span className="text-green-400">{generalSettings.language}</span></p>
            <p>Date Format: <span className="text-green-400">{generalSettings.dateFormat}</span></p>
            <p>Currency: <span className="text-green-400">{generalSettings.currency}</span></p>
            <p>2FA Enabled: <span className="text-green-400">{securitySettings.twoFactorEnabled ? 'Yes' : 'No'}</span></p>
          </div>
        </div>

        {/* Test useOfferStats */}
        <div className="bg-zinc-800 p-6 rounded-lg border border-zinc-700">
          <h2 className="text-xl font-semibold mb-4 text-blue-400">useOfferStats Hook</h2>
          <div className="space-y-2 text-sm">
            <p>Total Offers: <span className="text-green-400">{stats.totalOffers}</span></p>
            <p>Accepted: <span className="text-green-400">{stats.acceptedOffers}</span></p>
            <p>Pending: <span className="text-green-400">{stats.pendingOffers}</span></p>
            <p>Total Clients: <span className="text-green-400">{stats.totalClients}</span></p>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-zinc-800 p-6 rounded-lg border border-zinc-700">
        <h2 className="text-xl font-semibold mb-4 text-purple-400">Status</h2>
        <p className="text-green-400">✅ Jeśli widzisz dane powyżej, nowe hooki działają!</p>
        <p className="text-gray-400 mt-2">Wersja: {new Date().toISOString()}</p>
      </div>
    </div>
  );
}
